<template>
  <div>
    <el-select style="width:100%;" id="bank_info" v-model="bank_info" @change="change" :placeholder="$t('deposit.upload.please_sel')">
      <el-option v-for="(item,key) in bankInfo" :key="key" :label="item.name" :value="item.name"></el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  props: ['bank'],
  data () {
    return {
      // list: [],
      bankInfo: '',
      bank_info: this.bank,
      dialogVisible: false,
      showClose: true,
      contiune: true
    }
  },
  mounted () {
    // TODO 请求银行账户列表
    this.getBankInfo()
    /*  this.list = [
      {
        label: '中国银行',
        value: 'B'
      },
      {
        label: '工商银行',
        value: 'A'
      }
    ] */
  },
  methods: {
    change (val) {
      this.$emit('change', this.bankInfo)
    },
    getBankInfo () {
      this.$api.getBankInfo({ 'accountNumber': '1008611001' }).then(result => {
        this.bankInfo = result.data.data
      })
    }
  }
}
</script>

<style scoped>
</style>
